<template>
  <div class="offers">
    <app-layout customToolbar centered>
      <template v-slot:body>
        <div class="container text-center col-lg-8 col-sm-12">
          <h1>Offers</h1>
          <div v-if="isFetchingOffers">
            <v-skeleton-loader
              v-for="i in 5"
              :key="i"
              type="list-item-avatar"
            />
          </div>
          <div v-else>
            <div v-if="isNotEmpty">
              <OfferList :offers="formattedOffers" />
              <v-pagination
                :total-visible="page.pageSize"
                v-if="showPagination"
                v-model="page.currentPage"
                @input="loadOffers"
                :length="page.lastPage"
              />
            </div>
            <EmptyStates
              v-else
              icon="offers-empty-state"
              description="No offers have been made yet"
            />
            <BaseFooter v-if="canCreateOffer">
              <div class="actions-bar">
                <NewOfferAction :currentBooking="currentBooking" />
              </div>
            </BaseFooter>
          </div>
        </div>
      </template>
    </app-layout>
  </div>
</template>

<script>
import appLayout from "@/components/common/base-layouts/AppLayout";
import BaseFooter from "@/components/common/BaseFooter";
import NewOfferAction from "@/views/bookings/Offers/components/actions/NewOfferAction";
import OfferList from "@/views/offers/components/OfferList";
import { FETCH_OFFERS } from "@/store/modules/offers/actions";
import { OFFERS_NAMESPACE } from "@/store/modules/offers";
import { createNamespacedHelpers } from "vuex";
import { map, size } from "lodash";
import { getFullName } from "@/utils/users";
import { isPermissioned } from "@/utils/permissions";
import EmptyStates from "@/components/common/EmptyStates";
import { paginationMixin } from "@/mixins/pagination.mixin";

const { mapActions, mapState } = createNamespacedHelpers(OFFERS_NAMESPACE);

export default {
  mixins: [paginationMixin],
  props: {
    currentBooking: Object
  },
  components: {
    appLayout,
    BaseFooter,
    NewOfferAction,
    OfferList,
    EmptyStates
  },
  created() {
    this.loadOffers();
  },
  computed: {
    ...mapState(["offers", "isFetchingOffers"]),
    requestParams() {
      return {
        filter: {
          booking_id: this.currentBooking.id
        },
        ...this.requestPageParams
      };
    },
    formattedOffers() {
      return map(this.offers, offer => {
        const { user, booking } = offer.application;
        const candidate = getFullName(user);
        const { title } = booking;
        return { ...offer, candidate, title };
      });
    },
    canCreateOffer() {
      return (
        isPermissioned("applications.actions.make-offer") &&
        isPermissioned("offers.edit")
      );
    },
    isNotEmpty() {
      return size(this.formattedOffers);
    }
  },
  methods: {
    ...mapActions({
      fetchOffers: FETCH_OFFERS
    }),
    async loadOffers() {
      const data = await this.fetchOffers(this.requestParams);
      if (data) {
        this.updatePageDetails(data.meta);
      }
    }
  }
};
</script>

<style lang="scss">
.offers {
  position: relative;

  tr {
    cursor: pointer;
  }

  .footer {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    background-color: transparent;
    -webkit-box-shadow: none;
    box-shadow: none;
    -webkit-backdrop-filter: none;
    backdrop-filter: none;
    border-top: none;
  }
}
</style>
